import type { GenericFieldConfig } from '@neo/blocks/forms/types'
import { v2validations } from '../config/validation.config'
import type { ContactScreeningNodeData, SidebarComponentProps } from '../types'
import {
  callStartBehaviorField,
  screeningContextCard,
  useVoicemailPortWiring,
  voicemailDetectionCard,
} from './screening-shared'
import { GenericSidebarComponent } from './sidebar.base'

type FormValues = ContactScreeningNodeData['config']

const fields = (nodeVars: string[]): GenericFieldConfig<FormValues> => {
  const validations = v2validations({ nodeVars }).contact_screening
  return [
    {
      name: 'name',
      componentType: 'input',
      label: 'Name',
      zodValidation: validations.shape.name,
      inputProps: {
        placeholder: 'Enter name',
      },
    },
    screeningContextCard<FormValues>({
      nodeVars,
      contextValidation: validations.shape.context,
      askPermissionValidation: validations.shape.ask_permission,
    }),
    callStartBehaviorField<FormValues>(validations.shape.initial_wait_time, {
      collapsible: true,
    }),
    voicemailDetectionCard<FormValues>(validations.shape.voicemail_detection_next_node),
  ]
}

export const ContactScreeningSidebarComponent = (
  props: SidebarComponentProps<ContactScreeningNodeData>,
) => {
  const { nodeVars, selectedNode } = props
  const { defaultValues, handleFormSave } = useVoicemailPortWiring(selectedNode)
  const formFields = fields(nodeVars)

  return (
    <GenericSidebarComponent
      defaultValues={defaultValues}
      fields={formFields}
      callback={handleFormSave}
      {...props}
    />
  )
}
